import { useState, useEffect } from "react";

import './ConfigDash.css';

import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

import { SvgSave, SvgSetaDown, SvgSetaRight, SvgSetaUp } from "components/SvgFile";

import { GetDataPage, RegisterDataPage } from "interface/Data";
import { SetModalData, SetModalState } from "interface/PopUp";
import { Reg_AltPositionMenu, Reg_EditConfig, Reg_StatusMenu } from "services/RegisterData";

export default function Page_ConfigDash(){
    
    const [ loading, setLoading ]   = useState(false);
    const [ dataPage, setDataPage ] = useState(GetDataPage('dataConfig'));

    const [ idiomaEn, setIdiomaEn ] = useState(InitialDataIdioma('en'));
    const [ idiomaEs, setIdiomaEs ] = useState(InitialDataIdioma('es'));
    const [ listMenu, setListMenu ] = useState(InitialDataIdioma('list_menu'));

    useEffect(()=>{
        RegisterDataPage('dataConfig', setDataPage);
    }, []);

    useEffect(()=>{
        setDataPage(GetDataPage('dataConfig'));
        
        setIdiomaEn(InitialDataIdioma('en'));
        setIdiomaEs(InitialDataIdioma('es'));
        setListMenu(InitialDataIdioma('list_menu'));
    }, [dataPage]);

    function InitialDataIdioma(type){
        return dataPage[type];
    }

    function SaveData(event){
        event.preventDefault();
        setLoading(true);
        Reg_EditConfig(idiomaEn, idiomaEs, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    function CallbackSuccess(){
        setLoading(false);
        SetModalData('ReturnResponse', { "page": "ok" });
        SetModalState('ReturnResponse', true);
    }

    function CallbackError(){
        setLoading(false);
        SetModalData('ReturnResponse', { "page": "erro" });
        SetModalState('ReturnResponse', true);
    }

    function HandleData(index, value){
        const newData          = [...listMenu];
        newData[index]['name'] = value;
        setListMenu(newData);
    }

    function ChangePosition(id, order, type){
        setLoading(true);
        Reg_AltPositionMenu(id, order, type, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    function AltStatus(id, status){
        setLoading(true);
        Reg_StatusMenu(id, status, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    return(
        <div className="Page_ConfigDash">
            <div className={ loading == true ? "return_data_save div_loading" : "return_data_save" }>
                <img alt="loading" src="./assets/loading.gif" className="loading" />
            </div>
            <form onSubmit={ SaveData }>
                <div className="new_block">
                    <div className="div_name_page">
                        <div className="name_fixed">
                            Dashboard
                        </div>
                        <div className="show_icon">
                            <SvgSetaRight color="#CDD1D6" className="icons" />
                        </div>
                        <div className="name_page">
                            Settings
                        </div>
                    </div>
                    <div className="list_opt_alt_page">
                        <button className="new_block_text">
                            <div className="">
                                <SvgSave color="#ffffff" className="icons" />
                            </div>
                            <div className="">To save</div>
                        </button>
                    </div>
                </div>
                <div className="">
                    <div className="show_page_data"> 
                        <div className="list_type_data">
                            <div className="type_title">Languages active on the site</div>
                        </div>
                        <div className="list_opt_idioma">
                            <div className={ idiomaEn == true ? "div_idioma idioma_active" : "div_idioma" } onClick={ ()=>{ setIdiomaEn(!idiomaEn) } }>English</div>
                            <div className={ idiomaEs == true ? "div_idioma idioma_active" : "div_idioma" } onClick={ ()=>{ setIdiomaEs(!idiomaEs) } }>Spanish</div>
                        </div>
                    </div>

                    <div className="show_page_data"> 
                        <div className="list_type_data">
                            <div className="type_title">List website menus</div>
                        </div>
                        <table width="100%" cellPadding="0" cellSpacing="0">
                            <tbody>
                                <tr>
                                    <th width="20" align="center">#</th>
                                    <th>Nome</th>
                                    <th width="60">Status</th>
                                    <th width="60" align="right">Ordem</th>
                                </tr>
                            </tbody>
                            <tbody>
                                {
                                    listMenu.map((key, index)=>{
                                        return(
                                            <tr key={ index }>
                                                <td align="center">{ index + 1 }</td>
                                                <td>
                                                    <input type="text" className="input_table" onChange={ (e)=>{ HandleData(index, e.target.value); } } value={ key.name } />
                                                </td>
                                                <td>
                                                    {
                                                        key.status == 0 ? 
                                                        <div className="status_name disabled" onClick={ ()=>{ AltStatus(key.id, 1) } }>Desativado</div> 
                                                        : 
                                                        <div className="status_name active" onClick={ ()=>{ AltStatus(key.id, 0) } }>Ativado</div>
                                                    }
                                                </td>
                                                <td align="right">
                                                    <div className="div_opt_alt">
                                                        {
                                                            index == 0 ?
                                                            <div className="space_div_icon" /> :
                                                            <div data-tooltip-id={ "position_" + key.id } data-tooltip-content="Alterar posição" data-tooltip-place="top" className="space_div_icon" onClick={ ()=>{ ChangePosition(key.id, key.order_, 'up') } }>
                                                                <SvgSetaUp color="#324d6b" className="icons"/>
                                                            </div>
                                                        }
                                                        {
                                                            (index + 1) == listMenu.length ?
                                                            <div className="space_div_icon" /> :
                                                            <div data-tooltip-id={ "position_" + key.id } data-tooltip-content="Alterar posição" data-tooltip-place="top" className="space_div_icon" onClick={ ()=>{ ChangePosition(key.id, key.order_, 'down') } }>
                                                                <SvgSetaDown color="#324d6b" className="icons"/>
                                                            </div>
                                                        }
                                                        <Tooltip id={ "position_" + key.id } />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </form>
        </div>
    );
}